<template>
  <div :class="`alert-container additional-message${customClass.length > 0 ? ` ${customClass}` : ''}`">
    <p class="alert" v-if="icon">
      <i :class="`fa fa-${icon} fa-2x`" />
      <span :class="`ob1-alert-title${!maxWidth ? ' no-max-width' : ''}`">{{ title }}</span>
    </p>
    <div v-if="subtitle" class="alert-content">
      <p class="alert-text">{{ subtitle }}</p>
    </div>
    <div v-else-if="button" class="alert-content">
      <button @click="action" class="btn btn-secondary" type="button">{{ button }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NeutralAlert',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
      default: null,
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
    button: {
      type: String,
      required: false,
      default: null,
    },
    action: {
      type: Function,
      required: false,
      default: () => {return}
    },
    maxWidth: {
      type: Boolean,
      required: false,
      default: true,
    },
    customClass: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.alert-container {
  max-width: 780px;
  
  .fa {
    position: static;
    font-size: 2rem;
    font-weight: 400;
    line-height: 1;
    flex-shrink: 0;
    width: 3rem;
    margin: -0.0625rem 0;
    speak: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
  }

  .ob1-alert-title {
    &.no-max-width {
      max-width: unset;
    }
  }
}
</style>